import { genSliceInit } from '../utils';
import { osuiCssVarsSlice } from './reduxSlice';
export var initOSUICssVarsStore = genSliceInit(osuiCssVarsSlice);
//# sourceMappingURL=es/loadOSUICssVars/initOSUICssVarsStore.js.map